interface ProjectHeroDisplayProps {
  /** Display-size signed URL. Null → render nothing. */
  displayUrl: string | null
  alt: string
}

/**
 * Phase 8 — full-width hero rendered above the project title on /p/:handle/:slug. Lazy-loaded;
 * graceful fallback to nothing when the project has no hero.
 */
export const ProjectHeroDisplay = ({ displayUrl, alt }: ProjectHeroDisplayProps) => {
  if (!displayUrl) return null
  return (
    <div
      data-testid="project-hero-display"
      className="aspect-video w-full overflow-hidden rounded-lg bg-muted shadow-sm sm:max-h-[360px]"
    >
      <img src={displayUrl} alt={alt} className="h-full w-full object-cover" loading="lazy" />
    </div>
  )
}
